import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=2e68f6cd&scoped=true&lang=pug&"
import script from "./Shop.vue?vue&type=script&lang=ts&"
export * from "./Shop.vue?vue&type=script&lang=ts&"
import style0 from "./Shop.vue?vue&type=style&index=0&id=2e68f6cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e68f6cd",
  null
  
)

export default component.exports